var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"gap my-3"},[_c('b-col',{attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_vm._t("left")],2),_c('b-col',{attrs:{"cols":"4"}},[_vm._t("right")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }